import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const PuzzleFive = () => {
    return (
        <div className="App">
            <div className="App-body">
                <h1>Puzzle Five: Decoding </h1>
                <p>
                You continue navigating the depths of the flash drive until you reach the last few files. 
                It’s crucial to explore these carefully, as they may hold the final pieces to understanding 
                Nina’s intent and the broader implications of what you’ve uncovered. <br></br> <br></br>

                You discover a folder intriguingly labeled "Secure Contact Protocols." 
                Inside, several documents catch your eye, each marked with a word that resonates with 
                corporate influence and journalistic endeavor.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='/BoxThree/PuzzleFiveTwo'>Continue</Button>
            </div>
        </div>
    );
  };
  
export default PuzzleFive;
  